import { render, staticRenderFns } from "./ListItemExtracted.vue?vue&type=template&id=aaa85aa0"
import script from "./ListItemExtracted.vue?vue&type=script&lang=js"
export * from "./ListItemExtracted.vue?vue&type=script&lang=js"
import style0 from "./ListItemExtracted.vue?vue&type=style&index=0&id=aaa85aa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports